
import Vue from "vue";
import { APPLICATION } from "@/store/applications";
import { mapState } from "vuex";
import { IRootState } from "@/store/types";
import { OLA_BASE_URL } from "@/helpers/config";
import store from "@/store";

export default Vue.extend({
  data() {
    return {
      isLoading: false,
      headers: [
        { text: "Id", value: "id" },
        { text: "Applicant name", value: "fullName" },
        { text: "Business name", value: "businessName" },
        { text: "Created date", value: "createdDate" },
        { text: "Expired", value: "isExpired" },
        { text: "Status", value: "status" }
      ]
    };
  },
  computed: {
    pagination: {
      get() {
        return store.state.application.dataTables.drafts.pagination;
      },
      set(value: string) {
        this.$store.commit(
          APPLICATION.NS(APPLICATION.MUTATIONS.SET_DRAFT_APPLICATIONS_PAGINATION),
          value
        );
      }
    },
    ...mapState({
      draftApplications: (state: IRootState) => state.application.draftsList,
      totalApplications: (state: IRootState) =>
        state.application.draftsListTotal
    })
  },
  methods: {
    async onSearch() {
      this.isLoading = true;

      await this.$store.dispatch(
        APPLICATION.NS(APPLICATION.ACTIONS.LOAD_DRAFT_LIST),
        {
          pagination: this.pagination
        }
      );

      this.isLoading = false;
    },
    goToApplication(item: any) {
      if (!item.isExpired) {
        const draftUrl = `${OLA_BASE_URL}/form/${item.externalId}/draft/${
          item.draftId
          }`;

        // Open a new browser tab and navigate to the application draft
        window.open(draftUrl, "_blank");
      }
    }
  }
});
